/* No menu, cart, network or commerce handlers: those stay entirely native. */
(() => {
  if (customElements.get('vitamii-mobile-glass')) return;

  class VitamiiMobileGlass extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      // Dedicated quiz/offer pages deliberately omit normal navigation.
      if (!this.header?.querySelector('.header__mobile header-drawer')) return;

      this.mobile = window.matchMedia('(max-width: 992px)');
      this.compact = false;
      this.frame = 0;
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => this.render());
      };
      this.onBreakpoint = () => {
        if (this.mobile.matches) {
          this.header.classList.add('vtm-glass-ready');
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('pageshow', this.onScroll);
          this.render();
        } else {
          this.detach();
        }
      };
      this.mobile.addEventListener('change', this.onBreakpoint);
      this.onBreakpoint();
    }

    render() {
      this.frame = 0;
      if (!this.mobile.matches || !this.isConnected) return;
      // The native menu fixes the body and temporarily resets window.scrollY.
      // Keep the capsule stable until that component restores the saved scroll.
      if (document.body.classList.contains('fixed-position')) return;
      const y = Math.max(0, window.scrollY);
      const next = this.compact ? y > 24 : y > 36;
      if (next !== this.compact) {
        this.compact = next;
        this.header.classList.toggle('vtm-glass-compact', next);
      }
    }

    detach() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('pageshow', this.onScroll);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.compact = false;
      this.header.classList.remove('vtm-glass-ready', 'vtm-glass-compact');
    }

    disconnectedCallback() {
      if (!this.mobile) return;
      this.mobile.removeEventListener('change', this.onBreakpoint);
      this.detach();
    }
  }

  customElements.define('vitamii-mobile-glass', VitamiiMobileGlass);
})();
